export class changeSystemVideoPlayer {
  attach() {
    $('#change-player').click(function () {
      var changeBtnId = $(this).attr('id')
      console.log(changeBtnId)
      $.meDialog.open2({
        id: 'dialog_change_video_player',
        url: '/account/admin_homepage.change_video_player/',
        width: 600,
        title: 'Change system video player?',
      })
    })
  } // ready
}
